<template>
<div class="minidiv">
    <b-link :to="{
        name: 'breakdown',
        params: { trackid: this.result.track_id },
      }" class="brel">
        <div class="flex-parent text-center pt-2">
            <p class="flex-child">{{ sn + ((page - 1) * interval) }}</p>
            <p class="flex-child">{{ result.category }}</p>
            <p class="flex-child">{{ result.institution_shortname }}</p>
            <p class="flex-child">{{ result.mode }}</p>
            <div class="flex-child totsco">
                <div v-if="result.mode != 'Flexible'">
                    <span :class="[ result.total_score <= 0.45 * result.total_marks ? 'lowscore' : 'highscore']" class="red">
                        {{ result.total_score }}
                    </span>/ {{ result.total_marks }}
                </div>

                <div v-if="result.mode == 'Flexible'">
                    <span :class="[ result.total_score <= 0.45 * result.mode_config.total_mark ? 'lowscore' : 'highscore' ]" class="red">
                        {{ result.total_score }}
                    </span>/{{ result.mode_config.total_mark }}
                </div>
            </div>
            <p class="flex-child"><b-link :to="{ name: 'breakdown', params: { trackid: this.result.track_id }, query: { fromp: $route.name }}" class="link-sol">View solutions</b-link></p>
        </div>

    </b-link>
</div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    props: ["result", 'sn', 'page', 'interval'],
    data() {
        return {
            overallscore: 0
        };
    },
    created() {
        this.retrieveInstitutions().then(() => {
            let insti = this.result.institution;
            let category = this.result.category;
            let structure = this.result.structure;

            if (structure == "Section") {
                let level = this.result.level;
                let course = this.result.course;

                let levell = this.allinsti
                    .filter(x => x.name == insti && x.category == category)
                    .map(x => x.levels_config);
                let lev = JSON.parse(levell);
                let rlevel = lev.filter(x => x.name == level).map(y => y.config);

                let rlev = rlevel[0];
                //console.log(rlev);
                let icourses = rlev.filter(x => x.name == "courses").map(x => x.values);
                let itm = rlev.filter(x => x.name == "totalmarks").map(x => x.values);

                let rcindex = icourses[0].indexOf(course);
                let rtm = itm[0][rcindex];

                this.overallscore = Number(rtm);

                //console.log(rtm);
                //console.log(rcindex);
            } else {
                let overall = this.allinsti
                    .filter(x => x.name == insti)
                    .map(x => x.total_marks);
                //console.log(overall[0])
                this.overallscore = overall[0];
            }
        });
    },
    methods: {
        ...mapActions(["dashboard/getminiresults"]),
        ...mapActions("exam", ["retrieveInstitutions"])
    },
    computed: {
        ...mapState({
            allinsti: state => state.exam.allinstitutions
        })
    }
};
</script>

<style scoped>
.minidiv {
    border-radius: 10px 10px;
    background-color: white;
    overflow-x: scroll
}

.rins {
    font-size: 0.75rem;
}

.lowscore {
    color: red;
}

.highscore {
    color: #00377b;
}

.totsco {
    color: #00377b;
    font-weight: bolder;
}

.brel {
    text-decoration: none;
    color: black;
}
.link-sol{
  text-decoration : none;
  color :  #00984a;
}

.flex-parent {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    height: 50px;
}

.flex-child {
    width: 15%;
}
@media screen and (max-width: 768px) {
     .flex-child{
        font-size: 0.75rem
    }
    .link-sol{
        font-size: 0.55 rem
      }
}
</style>
